export default __webpack_public_path__ + "static/timeline-23ac40d8cc87b83d1298b01979589777.svg";